import React from "react";
import { Routes, Route } from "react-router-dom";
import { pdfjs } from "react-pdf";
import Home from "./Home/Home";
import { Start } from "./Start/Start";
import { Select } from "./Select/Select";
import { Done } from "./Done";
import { Score } from "./Score/Score";
import { Account } from "./Account/Account";
import { AccountInfo } from "./Account/AccountInfo";
import { Questionnaire } from "./Questionnaire/Questionnaire";
import { Jobs } from "./Jobs/Jobs";
import { Login } from "./Login";
import { Signup } from "./Signup";
import { Forgot } from "./Forgot";
import { Change } from "./Change";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/start" element={<Start />} />
      <Route path="/details" element={<Select />} />
      <Route path="/done" element={<Done />} />
      <Route path="/score" element={<Score />} />
      <Route path="/resumes" element={<Account />} />
      <Route path="/account" element={<AccountInfo />} />
      <Route path="/jobs" element={<Jobs />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forgot" element={<Forgot />} />
      <Route path="/change" element={<Change />} />
    </Routes>
  );
}

export default App;
